module.exports = __webpack_public_path__ + "static/media/x.ac78f101.svg";